import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=6f0949cf&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0949cf')) {
      api.createRecord('6f0949cf', component.options)
    } else {
      api.reload('6f0949cf', component.options)
    }
    module.hot.accept("./Collapsible.vue?vue&type=template&id=6f0949cf&", function () {
      api.rerender('6f0949cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Collapsible.vue"
export default component.exports